import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=6ecf6b74&scoped=true&"
import script from "./Telegram.vue?vue&type=script&lang=js&"
export * from "./Telegram.vue?vue&type=script&lang=js&"
import style0 from "./Telegram.vue?vue&type=style&index=0&id=6ecf6b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecf6b74",
  null
  
)

export default component.exports